const initialState = {};

function reducer(state = initialState, action) {
    switch (action.type) {
        case "memberBenefit":
            return Object.assign({}, state, action.data);

        default:
            return state;
    }
}

const data = {
    name: "memberBenefit",
    reducer: reducer,
};

export default data;